<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-briefcase" aria-hidden="true"></i> {{ "TITLE.JOB" | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="jobform">
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-university"></i></div>
          </div>
          <select class="form-control ml-1 custom-width-select"
                  [(ngModel)]="partnerSelected"
                  (ngModelChange)="reloadEnterprises()"
                  formControlName="partner">
            <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <label class="font-weight-bold" for="enterpriseInput">{{ "LABEL.ENTERPRISE" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-building"></i></div>
          </div>
          <select id="enterpriseInput"
                  class="form-control"
                  [(ngModel)]="job.enterpriseId"
                  formControlName="enterprise">
            <option *ngFor="let enterprise of enterprises"
                    [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="font-weight-bold" for="descriptionInput">{{ "LABEL.DESCRIPTION" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-keyboard"></i></div>
          </div>
          <input type="text"
                 id="descriptionInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-JOB' | translate }}"
                 [(ngModel)]="job.description"
                 formControlName="description"
                 [class.is-invalid]="isInvalidControl('description')">
        </div>
        <small *ngIf="isInvalidControl('description')"
               class="text-danger">
          {{ "MESSAGE.ENTER-JOB-DESCRIPTION" | translate }}
        </small>
      </div>
      <div class="row">
        <div class="col" *ngIf="!isNewJob">
          <label for="state" class="col-form-label font-weight-bold"> {{ "LABEL.STATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{ isActiveJob ? 'input-group-text' : 'input-group-text-danger' }}">
                <i class="{{ isActiveJob ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
            <select class="form-control"
                    id="state"
                    formControlName="status"
                    [(ngModel)]="job.active"
                    [class.is-invalid]="isInvalidControl('status')">
              <option [value]="1">{{ "LABEL.ACTIVE" | translate }}</option>
              <option [value]="0">{{ "LABEL.INACTIVE" | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fas fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fas fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
